<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />


      <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Zonas {{negocio.negocio}}</h1>
        <br/>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
          {{ mensajeborrar }}
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Zona se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Zona se edito con éxito.
       </v-alert>
        <v-data-table
      :headers="headers"
      :items="Zonas"
      sort-by="zona"
      sort-desc
      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Zonas</v-toolbar-title>
          <v-progress-circular
        indeterminate
        v-if="progr == true"
        color="primary"
      ></v-progress-circular>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Zona</v-btn>
            </template>
            <v-card  color="#393E46">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.zona" label="Nombre"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card  color="#393E46">
          <v-card-title class="headline">Desea eliminar esta Zona?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          color="primary"
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
          </template>
          <span>Actualizar Zona</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          color="error"
          v-bind="attrs"
          v-on="on"
          @click="deleteItem(item)"
        >
          fas fa-minus-circle
        </v-icon>
          </template>
          <span>Borrar Zona</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dameZonas">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import moment from "moment";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      overlay:false,
      negocio: {},
      abreviado:'NN',
      token:'',
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Zonas',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      mensajeborrar:'Su Zona se borro con éxito.',
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      Zonas: [],
      search: '',
      editedIndex: -1,
      editedItem: {
      id: 0,
      zona: '',
        negocio: {},
        activo: true,
        createdAt: new Date()
    },
    defaultItem: {
      id: 0,
      zona: '',
      negocio: {},
      activo: true,
      createdAt: new Date()
    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Zona', align: 'left',  value: 'zona'},
        { text: 'Negocio', value: 'negocio.negocio' },
      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
        this.dbreads[0].text = this.negocio.negocioNombre
    if (this.usuario.id === undefined){

      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.dameZonas();
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.dameZonas();
    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else {
        this.dbreads[0].text = this.negocio.negocioNombre
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.dameZonas();
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      }

    },
  },
  methods : {
    dameZonas(){
      this.progr = true;
      this.overlay = true;
        axios
        .get('zonas/negocio/' + this.idnegocio ,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Zonas = response.data;
            this.progr = false;
            this.overlay = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        this.overlay = false
          this.progr = false;
        });
    },
    editItem (item) {
      this.editedIndex = this.Zonas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.Zonas.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      let md555 = this.Zonas[this.editedIndex].id;
      axios
      .delete('zonas/negocio/'+md555,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.mensajeborrar = response.data.mensaje;
        let okmsg = response.data.ok;
        if(okmsg){
          this.Zonas = response.data.zonaNegocioEntityList;
        }
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.Zonas[this.editedIndex], this.editedItem);
        if(this.editedItem.createdAt == null){
          this.editedItem.createdAt = new Date();
        }
        this.editedItem.createdAt = this.formatDateee(new Date(this.editedItem.createdAt))
        this.editedItem.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.negocio.cliente.createdAt))

        var bodyFormData2 = new FormData();
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
      .post('zonas/negocio/grabar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
                this.dameZonas();
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      } else {
        var bodyFormData = new FormData();

        this.editedItem.createdAt = this.formatDateee(this.formatDateee(Date.now()));
        this.editedItem.negocio = this.negocio;
        this.editedItem.negocio.cliente.createdAt = this.formatDateee(new Date(this.editedItem.negocio.cliente.createdAt))

        bodyFormData.append("data",JSON.stringify(this.editedItem));

        axios
      .post('zonas/negocio/grabar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                this.Zonas = response.data;
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Zona' : 'Editar Zona'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
